import ISO6391 from "iso-639-1";
export const languagesOptions = ISO6391.getAllCodes().sort((iso1, iso2) => ISO6391.getName(iso1) > ISO6391.getName(iso2) ? 1 : ISO6391.getName(iso1) < ISO6391.getName(iso2) ? -1 : 0);
